import { __awaiter, __extends, __generator } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import AppSettingServices from '@/modules/settings/app/AppSettingServices';
var appSettings = {
  text_local: '',
  text_local_es: '',
  text_local_en: '',
  local_payments: '',
  domicile_payments: '',
  pickup_payments: '',
  use_vibrant: false
};

var AppSettingsModel =
/** @class */
function (_super) {
  __extends(AppSettingsModel, _super);

  function AppSettingsModel() {
    var _this = _super.call(this, appSettings, AppSettingServices) || this;

    _this.modelName = 'App';
    _this.request = 'JSON';
    return _this;
  }

  AppSettingsModel.prototype.create = function (data, toast, toastConfig) {
    return __awaiter(this, void 0, void 0, function () {
      var request;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.request({
              method: 'PUT',
              query: data
            })];

          case 1:
            request = _a.sent();

            if (request.complete) {
              return [2
              /*return*/
              , this.handleSuccess(request.data, request.message, toast)];
            } else {
              this.handleError(request, toast);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return AppSettingsModel;
}(BaseModel);

export default AppSettingsModel;